import React from 'react'
import Pg3 from '../../../myapp/services/add-money/Pg/Pg3'

function PG3Page() {
  return (
    <Pg3/>
  )
}

export default PG3Page